import { Box, Typography } from "@mui/material";
import robotImage from "../assets/RobioActions/robio_standing.png";
import robotSleeping from "../assets/RobioActions/robio_sleeping.png"

function ComingSoon() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      <Box >
        <img
          src={robotSleeping}
          alt="AI Robot"
          style={{
            width: 300,
            height: "auto",
            animation: "float 3s ease-in-out infinite",
            filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.25))",
          }}
        />
      </Box>

      <Typography
        variant="h2"
        fontWeight={800}
        gutterBottom
        sx={{
          background: "linear-gradient(90deg,#1e3a8a,#3b82f6)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: 1,
        }}
      >
        Coming Soon
      </Typography>

      <Typography variant="h6" color="text.secondary" maxWidth={600}>
        We’re crafting something intelligent, intuitive, and beautiful. Stay
        tuned for the launch!
      </Typography>

      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0); }
            50% { transform: translateY(-12px); }
            100% { transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  );
}

export default ComingSoon;
